export const iconFontAwesomeTextformattingAlignJustify = (
	<i className="fa-solid fa-align-justify"></i>
);
